import { ErrorPayload } from './types';

export const formatErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'object' && error !== null) {
    try {
      return JSON.stringify(error, null, 2);
    } catch {
      return String(error);
    }
  }
  return String(error);
};

const formatErrorDetails = (error: unknown) => {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  if (typeof error === 'object' && error !== null) {
    return JSON.parse(JSON.stringify(error)); // Handle circular references
  }

  return String(error);
};

export const logError = (error: unknown, event: ErrorPayload) => {
  const formattedError = formatErrorDetails(error);

  const errorDetails = {
    error: formattedError,
    eventName: event.name,
    eventType: event.properties?.['fr_form_type'] || 'Unknown',
    timestamp: Date.now(),
  };

  fetch('/api/log/', {
    method: 'POST',
    body: JSON.stringify({
      attributes: event,
      message: 'Amplitude tracking error',
      errorMessage:
        typeof formattedError === 'object'
          ? JSON.stringify(formattedError, null, 2)
          : formattedError,
      details: errorDetails,
    }),
  });
};
